<template>
  <div>
    <h1 style="text-align: center">Не можем да намерим страницата, която търсите.</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
